export const ICON_SIZE_14 = 14;
export const ICON_SIZE_16 = 16;
export const ICON_SIZE_18 = 18;
export const ICON_SIZE_20 = 20;
export const ICON_SIZE_22 = 22;
export const ICON_SIZE_24 = 24;
export const ICON_SIZE_26 = 26;
export const ICON_SIZE_28 = 28;
export const ICON_SIZE_32 = 32;
export const ICON_SIZE_40 = 40;
export const ICON_SIZE_42 = 42;
export const ICON_SIZE_48 = 48;
export const ICON_SIZE_56 = 56;
export const ICON_SIZE_64 = 64;
export const ICON_SIZE_100 = 100;
export const ICON_SIZE_120 = 120;
export const ICON_SIZE_180 = 180;
export const ICON_SIZE_200 = 200;
